import { makeAutoObservable } from 'mobx';
import { ViewName } from '@tools/ui/enums';

class BusyStore {
  view: ViewName | undefined;

  constructor() {
    makeAutoObservable(this);
  }

  getView() {
    return {
      view: this.view
    };
  }

  setView(view?: ViewName) {
    this.view = view;
  }
}

export default new BusyStore();
